import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, combineLatest } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import * as fromRoot from '../../core/store';

@Injectable()
export class AuthenticationGuard  {
    constructor(private router: Router, private store: Store<fromRoot.State>) { }

    canActivate(): Observable<boolean> {
        return combineLatest([
            this.store.select(fromRoot.getUser),
            this.store.select(fromRoot.getUserComplete)
        ]).pipe(
            filter(([, complete]) => complete === true),
            take(1),
            map(([user]) => {
                if (user === null) {
                    this.router.navigate(['/login']);
                    return false;
                }
                return true;
            })
        );
    }

    canActivateChild(): Observable<boolean> {
        return this.canActivate();
    }
}
